import * as React from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

interface Props {
    labelText: string;
    checked: boolean;
    onClick: () => void;
    rowClassname?: string;
    opacity?: number;
}

const ContactCheckbox = (props: Props) => {
    const checkedImage = require('../../../../images/checkbox-checked.png');
    const uncheckedImage = require('../../../../images/checkbox.png');

    return (
        <section>
            <Row className={props.rowClassname || ''}>
                <Col className="col-1">
                    <img
                        src={props.checked ? checkedImage : uncheckedImage}
                        onClick={props.onClick}
                        className="contact-checkbox"
                        style={{ opacity: props.opacity }}
                    />
                </Col>
                <Col className="col-5 contact-checkbox-label">{props.labelText}</Col>
            </Row>
        </section>
    );
};

export default ContactCheckbox;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/account/ContactCheckbox.tsx